module.exports = __webpack_public_path__ + "static/media/cucumber.1dce2ee0.png";